import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import initApp from '@m/utils/initApp';
import AdminApp from 'apps/admin';

import * as serviceWorker from './serviceWorker';

if (!window.ResizeObserver) {
  /* eslint-disable global-require */
  window.ResizeObserver = require('resize-observer-polyfill');
  /* eslint-enable global-require */
}

initApp('admin');

const root = createRoot(document.getElementById('root')!);

KeycloakService.initKeycloak('login-required', () => {
  root.render(
    <Sentry.ErrorBoundary>
      <AdminApp />
    </Sentry.ErrorBoundary>,
  );
});

document.getElementById('initial-loader')?.remove();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
